import PropTypes from 'prop-types';
import React from 'react';

const Footer = ({ footers, surveyCode }) => (
  <>
    {footers?.map((item, i) => {
      const key = `footer${i}`;
      return (<p key={key} style={{ direction: 'LTR' }}>{surveyCode ? item.replace('[SURVEYCODE]', surveyCode.match(/.{1,4}/g).join(' ')) : item}</p>);
    })}
    {!!footers?.length && <br />}
  </>
);
Footer.defaultProps = {
  footers: [],
  surveyCode: ''
};

Footer.propTypes = {
  footers: PropTypes.arrayOf(PropTypes.string),
  surveyCode: PropTypes.string,
};

export default Footer;
